import * as _ from 'lodash'

import { BaseModel } from '../base-model'
import { FeeScheduleModel } from '../fee-schedule'
import { PriceData } from './price.data'

export interface PriceRequirements {
  carriers?: string[]
  carrierLookups?: string[]
}

export class PriceModel extends BaseModel {
  price: number
  priceCurrency: string
  requirements: PriceRequirements
  validFrom?: Date
  validTo?: Date
  productId?: string
  feeScheduleId?: string
  feeSchedule?: FeeScheduleModel
  code?: string

  constructor(data?: PriceData) {
    super(data)

    this.price = data?.price ?? 0
    this.priceCurrency = data?.priceCurrency ?? 'USD'
    this.requirements = data?.requirements ?? {}
    this.validFrom = data?.validFrom
    this.validTo = data?.validTo
    this.productId = data?.productId
    this.feeScheduleId = data?.feeScheduleId
    this.code = data?.code

    if (data?.feeSchedule) {
      this.feeSchedule = new FeeScheduleModel(data.feeSchedule)
    }
  }

  override toJSON() {
    return _.extend(super.toJSON(), {
      price: this.price,
      priceCurrency: this.priceCurrency,
      requirements: this.requirements,
      productId: this.productId,
      validFrom: this.validFrom,
      validTo: this.validTo,
      code: this.code,
    })
  }
}
